export const ORGANIZATION_CONFIG_QUERY_KEYS = {
  base: ["organizationConfig"] as const,
  color: ["organizationColor"] as const,
  // Under `base`, so invalidating the whole org config refreshes it too.
  features: ["organizationConfig", "features"] as const,
};
